import { useTranslation } from 'react-i18next';

import { SettingModelSettingType } from 'api/models';
import { ConnectorPlacementAction } from 'app/modules/wallforming/components/setting-container/connector-placement/ConnectorPlacementAction';
import { PanelPlacementAction } from 'app/modules/wallforming/components/setting-container/panel-placement/PanelPlacementAction';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

interface AutomatedPlacementActionProps {
    settingType: SettingModelSettingType;
}

const renderPlacementAction = (label: string, action: React.ReactNode) => (
    <div className="mt-2 flex w-full flex-row items-center">
        <div>{action}</div>
        <div className="px-2 text-sm">{label}</div>
    </div>
);

export const AutomatedPlacementAction = ({ settingType }: AutomatedPlacementActionProps) => {
    const { t } = useTranslation();
    const isPlacementDataInitialized = usePlacementStore((state) => state.isPlacementDataInitialized);

    if (settingType === SettingModelSettingType.Panels) {
        return renderPlacementAction(
            t('labelPlacePanels'),
            <PanelPlacementAction articleDataLoaded={isPlacementDataInitialized} />
        );
    }

    if (settingType === SettingModelSettingType.Connectors) {
        return renderPlacementAction(
            t('labelPlaceConnectors'),
            <ConnectorPlacementAction articleDataLoaded={isPlacementDataInitialized} />
        );
    }

    return null;
};
